import React from "react";

const SelectDeptment = ({ SelectDeptment }) => {
  // console.log(SelectDeptment, "SelectDeptment")
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
          width: "308px",
          margin: "0 auto",
        }}
      >
        <h3
          className="text-center"
          style={{ color: "#0C807D", fontSize: "28px", fontWeight: "500" }}
        >
          Department
        </h3>
        <img src="/assets/images/Rectangle 33.png" alt="" />
      </div>
      <div className="row mt-2">
        <div
          className="col-md-6"
          style={{
            backgroundColor: "#E6DFCF",
            width: "204px",
            height: "114px",
            borderRadius: "16px",
          }}
        >
          {SelectDeptment &&
            SelectDeptment.map((dpt) => (
              <h1>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
                totam distinctio qui, error quis sint ipsam. Iusto enim quo
                dolorem. Vitae quo labore perferendis alias voluptas doloribus
                quam. Mollitia, sed?
              </h1>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SelectDeptment;



// WEBPACK FOOTER //
// ./src/component/SelectDeptment.js